import UserMenuPanel from 'features/UserMenu/components/UserMenuPanel/UserMenuPanel';
import { Button } from 'react-bootstrap';
import { IoAccessibility, IoMapOutline, IoSaveOutline } from 'react-icons/io5';

/** Share one settings layout, with colors selected by the navigation appearance. */
const AccessibilityForm = ({
  controls,
  mapPreview,
  chartPreview,
  saveStatus,
  onSave,
  isClassic,
}) => {
  const isSaving = saveStatus === 'saving';

  return (
    <div
      className="user-menu-page accessibility-page"
      data-appearance={isClassic ? 'classic' : 'merlin'}
    >
      <div className="user-menu-grid" data-layout="sidebar">
        <UserMenuPanel icon={<IoAccessibility />} title="Accessibility">
          <div className="d-flex flex-column gap-3">
            {controls.theme}
            {controls.navigation}
            {controls.colorMode}
            <div className="user-menu-actions pt-1">
              <p
                className="user-menu-status"
                role="status"
                data-tone={saveStatus === 'error' ? 'error' : 'success'}
              >
                {saveStatus === 'saved' ? 'Settings saved' : null}
                {saveStatus === 'error' ? 'Unable to save settings' : null}
              </p>
              <Button
                variant={isClassic ? 'secondary' : 'primary'}
                className="d-flex align-items-center justify-content-center gap-2"
                onClick={onSave}
                disabled={isSaving}
              >
                <IoSaveOutline aria-hidden="true" />
                {isSaving ? 'Saving...' : 'Save Settings'}
              </Button>
            </div>
          </div>
        </UserMenuPanel>

        <UserMenuPanel
          icon={<IoMapOutline />}
          title="Site Settings"
          description="These settings apply per user on this browser"
        >
          <div className="user-menu-grid" data-layout="halves">
            <div className="d-flex flex-column gap-3">
              <p className="user-menu-subheading mb-0">Map Settings</p>
              {controls.mapStyle}
              {mapPreview}
            </div>
            <div className="d-flex flex-column gap-3">
              <p className="user-menu-subheading mb-0">Chart Settings</p>
              {controls.chartStyle}
              {chartPreview}
            </div>
          </div>
        </UserMenuPanel>
      </div>
    </div>
  );
};

export default AccessibilityForm;
